import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { PAGE_CONTAINER_WIDTH } from '../constants';
import { fullHeightKeys, fullHeightMixin, marginVerticalKeys, marginVerticalMixin, paddingVerticalKeys, paddingVerticalMixin, relativeKeys, relativeMixin } from '../mixins/layout';
import { withOmitProps } from '../helpers/elements';
import { PAGE_CONTAINER_MAX_WIDTH } from './constants';
import { width } from '../style/width';
import { maxWidth } from '../style/max-width';
var PageContainer = styled.div.withConfig(withOmitProps([].concat(fullHeightKeys, marginVerticalKeys, paddingVerticalKeys, relativeKeys, ['withSafeBottomPadding', 'withSafeTopPadding', 'restricted'])))(_templateObject(), fullHeightMixin, relativeMixin, marginVerticalMixin, paddingVerticalMixin, width(PAGE_CONTAINER_WIDTH), function (_ref) {
  var _ref$withSafeBottomPa = _ref.withSafeBottomPadding,
      withSafeBottomPadding = _ref$withSafeBottomPa === void 0 ? false : _ref$withSafeBottomPa;
  return withSafeBottomPadding ? "padding-bottom: env(safe-area-inset-bottom);" : '';
}, function (_ref2) {
  var _ref2$withSafeTopPadd = _ref2.withSafeTopPadding,
      withSafeTopPadding = _ref2$withSafeTopPadd === void 0 ? false : _ref2$withSafeTopPadd;
  return withSafeTopPadding ? "padding-top: env(safe-area-inset-top);" : '';
}, function (_ref3) {
  var _ref3$restricted = _ref3.restricted,
      restricted = _ref3$restricted === void 0 ? false : _ref3$restricted;
  return restricted ? maxWidth(PAGE_CONTAINER_MAX_WIDTH) : '';
});
export default PageContainer;